import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Providers-Services
import { ApiRestService } from '../../services/shared/api-rest.service';

// Tablas
import { table } from '../../components/shared/tables';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService
  ) { }

  // Carga de arvhivos
  loadFile(file: File, name) {
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);
    // console.log(this._apiRestService.APIURL.serv9998 + `/{"objc":{"oc":${JSON.stringify(name)}}}`, formData);
    return this.http.post(this._apiRestService.APIURL.serv9998 + `/{"objc":{"oc":${JSON.stringify(name)}}}`, formData)
      .pipe(
        map(
          (res: any) => {
            let data = res;
            return data;
          }));
  }

  // Eliminar archivo
  deleteFile(prnt) {
    // console.log(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.file}","prnt":"${prnt}"}`);
    return this.http.get(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.file}","prnt":"${prnt}"}`
    ).pipe(
      map(
        (res: any) => {
          let data = res;
          return data;
        }));
  }

  // Descargar archivo
  // getFile(prnt) {
  //   console.log(this._apiRestService.APIURL.serv9997 + `/{"prnt":"${prnt}"}`);
  //   return this.http.get(this._apiRestService.APIURL.serv9997 + `/{"prnt":"${prnt}"}`
  //   ).pipe(
  //     map(
  //       (res: any) => {
  //         let data = res;
  //         return data;
  //       }));
  // }

}
